function initScrollReveal() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        setTimeout(() => initScrollReveal(), 100)
        return
    }

    gsap.registerPlugin(ScrollTrigger)

    const revealElements = document.querySelectorAll("[data-scroll-reveal]")

    if (!revealElements.length) return

    revealElements.forEach((element) => {
        gsap.fromTo(
            element,
            {
                opacity: 0,
                y: 8,
            },
            {
                opacity: 1,
                y: 0,
                duration: 2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 75%",
                    once: true,
                },
            }
        )
    })
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollReveal)
} else {
    initScrollReveal()
}


